/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AssetsUploadMutationRequest, AssetsUploadMutationResponse, AssetsUpload401, AssetsUpload403 } from "../models/AssetsUpload";
import { buildFormData } from "../.kubb/config";

export function getAssetsUploadUrl() {
  const res = { method: 'POST', url: `/assets/v1` as const }
  return res
}

/**
 * @summary Upload asset
 * {@link /assets/v1}
 */
export async function assetsUpload(data: AssetsUploadMutationRequest, config: Partial<RequestConfig<AssetsUploadMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<AssetsUploadMutationResponse, ResponseErrorConfig<AssetsUpload401 | AssetsUpload403>, AssetsUploadMutationRequest>({ method : "POST", url : getAssetsUploadUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}